import { WorkSheetGroupStatusModelType } from '@teinor/erp/types/company/order/sell/workSheet/workSheetGroupStatus'
import { dictionaryComplexFromJsonArr } from '../../globals/dictionary'
import { WorkSheetProductStatusModelType } from '@teinor/erp/types/company/order/sell/workSheet/workSheetProductStatus'

export interface WorkSheetGroupStatusesAction {
    type: 'CHANGE_WORKSHEETGROUPSTATUSES'
    payload: WorkSheetGroupStatusModelType[]
}
export type DictWorkSheetProductStatusTy = { [key: string]: WorkSheetProductStatusModelType }
type DictWorkSheetGroupStatusWithDict = WorkSheetGroupStatusModelType & {
    WorkSheetProductStatusesDict: DictWorkSheetProductStatusTy,
}

type DictWorkSheetGroupStatusTy = { [key: string]: DictWorkSheetGroupStatusWithDict }
type WorkSheetGroupStatusTy = {
    WorkSheetActiveStatusGroups: WorkSheetGroupStatusModelType[]
    dictWorkSheetGroupStatus: DictWorkSheetGroupStatusTy
}
export type WorkSheetGroupStatusesPayload = null | WorkSheetGroupStatusTy


export default function workSheetGroupStatuses(state: WorkSheetGroupStatusesPayload = null, action: WorkSheetGroupStatusesAction): WorkSheetGroupStatusTy | null {
    switch (action.type) {
        case 'CHANGE_WORKSHEETGROUPSTATUSES':
            const dictWorkSheetGroupStatus: DictWorkSheetGroupStatusTy = {}
            const WorkSheetActiveStatusGroups: WorkSheetGroupStatusModelType[] = []
            for (const workSheetGroupStatus of action.payload) {
                const WorkSheetProductStatusesDict = dictionaryComplexFromJsonArr(workSheetGroupStatus?.WorkSheetProductStatuses || [])
                dictWorkSheetGroupStatus[workSheetGroupStatus.id] = {
                    ...workSheetGroupStatus,
                    WorkSheetProductStatusesDict,
                }
                if (workSheetGroupStatus.active) {
                    WorkSheetActiveStatusGroups.push(workSheetGroupStatus)
                }
            }
            return state = {
                dictWorkSheetGroupStatus,
                WorkSheetActiveStatusGroups
            }
        default:
            return state
    }
}